// Third-party
import React from 'react';

// Components
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';
import AdjustmentCell from './AdjustmentCell';
import PercentageCell from './PercentageCell';

type Props = {
  value: {
    value?: number;
    adjustment?: number;
  };
  className?: string;
  onClick?: () => void;
  id?: string;
  disclaimer?: string;
  hasDisclaimer?: boolean;
  item?: ComparisonItem;
  locale?: Locale;
  decimalPlace?: number;
};

const PercentageAdjustmentCell: React.FunctionComponent<Props> = ({
  value,
  className,
  disclaimer,
  item,
  onClick,
  id,
  hasDisclaimer,
  locale,
  decimalPlace,
}: Props) => (
  <div className="percentage-adjustment-cell">
    <PercentageCell
      value={value.value}
      className={`${className} percentage-adjustment-cell-content`}
      item={item}
      disclaimer={disclaimer}
      onClick={onClick}
      id={id}
      hasDisclaimer={hasDisclaimer}
      locale={locale}
      decimalPlace={decimalPlace}
    />
    {value.adjustment && (
      <AdjustmentCell
        value={value.adjustment}
        className={`${className} percentage-adjustment-cell-content`}
        onClick={onClick}
        id={id}
        disclaimer={disclaimer}
        hasDisclaimer={hasDisclaimer}
        item={item}
        locale={locale}
        decimalPlace={decimalPlace}
      />
    )}
  </div>
);

export default PercentageAdjustmentCell;
